__webpack_public_path__ = window._sharedData.config.url + 'assets/nhpc/js/';